var render, staticRenderFns
import script from "./ActivityItem.vue?vue&type=script&lang=tsx&"
export * from "./ActivityItem.vue?vue&type=script&lang=tsx&"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=157b2bfb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports